import Chip from "components/Chip/Chip";
import styles from "./Related.module.scss";

interface RelatedContentType {
  title: string;
  subTitle: string;
  type?: string;
  dataItems: {
    title: string;
    subTitle: string;
    status: string;
    value: string;
  }[];
}

const RelatedContent = ({ title, subTitle, type = "risk", dataItems }: RelatedContentType) => {
  return (
    <>
      <div className="mv-4">
        <h5 className="text-gray-200">{title}</h5>
        <p className="fw-400 text-1x text-gray-400">{subTitle}</p>
      </div>
      {dataItems.map((item, index) => (<><div key={`relatedItem${index}`} className="d-flex align-items-center justify-content-between mv-3">
        <div>
          <div className="text-1x text-gray-50 fw-400">{item.title}</div>
          <p className="text-1x text-gray-400 fw-300">{item.subTitle}</p>
        </div>
        <Chip variant={item.status} type="fill">
          <span className={`mr-2 ${styles.dot} bg-${item.status}-900`}></span>
          {item.value}
        </Chip>
      </div><hr /></>))}
      <button className="btn btn-flat text-gray-50 text-2c fw-400 flex-center mb-3">
        <i className="icon-plus text-5c mr-2"></i>
        Add new {type}
      </button>
    </>
  );
};

export default function Related() {
  const data = [
    {
      title: 'Geopolitical conflicts in Ukraine',
      subTitle: 'Q1 FY24 • Procurement',
      status: 'error',
      value: 'Very High'
    },
    {
      title: 'Factory shutdown in China',
      subTitle: 'Q1 FY24 • Procurement',
      status: 'error',
      value: 'Very High'
    },
    {
      title: 'Labor shortage',
      subTitle: 'Q1 FY24 • Procurement',
      status: 'error',
      value: 'Very High'
    },
    {
      title: 'Computer chip shortage',
      subTitle: 'Q1 FY24 • Procurement',
      status: 'error',
      value: 'Very High'
    }
  ];

  const data1 = [
    {
      title: 'Control name 1',
      subTitle: 'Control information',
      status: 'success',
      value: 'Effective'
    },
    {
      title: 'Control name 2',
      subTitle: 'Control information',
      status: 'success',
      value: 'Effective'
    },
    {
      title: 'Control name 3',
      subTitle: 'Control information',
      status: 'success',
      value: 'Effective'
    },
    {
      title: 'Control name 4',
      subTitle: 'Control information',
      status: 'success',
      value: 'Effective'
    }
  ];

  return (
    <div className="pv-2">
      <RelatedContent title="Related Risks" subTitle="We predict a large impact over the next 36 months in the following areas." dataItems={data} type={"risk"} />
      <RelatedContent title="Controls" subTitle="Your controls are effective but we have 3 new suggestions" dataItems={data1} type={"control"} />
    </div>
  );
}
